import { jsx, jsxs, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { GREY_BORDER_CARD } from "../../../foundations/colors.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { PracticeTurn } from "../../../foundations/practice-turn.es.js";
import { ONE_PIXEL_REM, Spacing } from "../../../foundations/spacing.es.js";
import { theme } from "../../../foundations/theme.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { forwardRef } from "react";
import styled from "../../../../node_modules/@mui/material/styles/styled.es.js";
import MuiCard from "../../../../node_modules/@mui/material/Card/Card.es.js";
import Grid from "../../../../node_modules/@mui/material/Grid/Grid.es.js";
import Typography from "../../../../node_modules/@mui/material/Typography/Typography.es.js";
import { CursorStyle } from "../../../foundations/cursor-style.es.js";
const CardContainer = styled(MuiCard, styledOptions)(({
  turnBorderColor,
  turn,
  theme: theme2
}) => {
  const fullBorderColor = turn === PracticeTurn.user ? turnBorderColor : GREY_BORDER_CARD;
  const leftBorderColor = turnBorderColor;
  const borderWidth = `${ONE_PIXEL_REM} ${ONE_PIXEL_REM} ${ONE_PIXEL_REM} ${theme2.spacing(2)}`;
  return {
    borderRadius: theme2.spacing(2),
    boxShadow: "none",
    padding: `${Spacing["1000"]} ${Spacing["1500"]}`,
    border: `solid ${fullBorderColor}`,
    borderWidth,
    borderLeft: `${theme2.spacing(2)} solid ${leftBorderColor}`,
    "&:hover": {
      cursor: CursorStyle.pointer
    }
  };
});
const ActionComponentStyled = styled("div", styledOptions)(({
  isFinalized
}) => {
  return {
    display: Displaying.flex,
    alignItems: Alignment.center,
    justifyContent: Alignment.spaceBetween,
    marginTop: isFinalized ? "0" : `${Spacing["1000"]}`,
    borderTop: isFinalized ? "0" : `${ONE_PIXEL_REM} solid ${GREY_BORDER_CARD}`,
    paddingTop: `${Spacing["1000"]}`
  };
});
const DivFlexedCentered = styled("div")({
  display: Displaying.flex,
  alignItems: Alignment.center,
  gap: `${Spacing["1000"]}`
});
const TicketCardMobile = forwardRef(function Card({
  turn,
  turnIconToRender,
  turnColor,
  actionComponent,
  date,
  productName,
  productRequestedCode,
  ...rest
}, ref) {
  const isFinalized = turn === PracticeTurn.finalized;
  const productCodeWithSymbol = `# ${productRequestedCode}`;
  return /* @__PURE__ */ jsx(CardContainer, { turnBorderColor: turnColor, turn, ref, ...rest, "data-testid": "ticket-card-container-mobile", children: /* @__PURE__ */ jsxs(Grid, { container: true, alignItems: Alignment.center, spacing: 1, rowSpacing: 1, children: [
    /* @__PURE__ */ jsxs(DivFlexedCentered, { children: [
      /* @__PURE__ */ jsx(Grid, { item: true, xs: "auto", style: {
        paddingTop: `${Spacing[500]}`
      }, "data-testid": "ticket-card-mobile-icon", children: turnIconToRender }),
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 10, children: /* @__PURE__ */ jsx(Typography, { variant: "body2", color: theme.palette.text.secondary, "data-testid": "ticket-card-mobile-date", children: date }) })
    ] }),
    /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", "data-testid": "ticket-card-mobile-product-name", children: productName }) }),
    isFinalized ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(Typography, { variant: "body1", color: theme.palette.text.secondary, "data-testid": "ticket-card-mobile-code", children: productCodeWithSymbol }) }),
    isFinalized ? /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsxs(ActionComponentStyled, { isFinalized, "data-testid": "ticket-card-mobile-action", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body1", color: theme.palette.text.secondary, "data-testid": "ticket-card-mobile-code", children: productCodeWithSymbol }),
      " ",
      actionComponent
    ] }) }) : /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(ActionComponentStyled, { isFinalized, "data-testid": "ticket-card-mobile-action", children: actionComponent }) })
  ] }) });
});
export {
  TicketCardMobile
};
//# sourceMappingURL=ticket-card-mobile.es.js.map
